import { VendorDetails } from 'app/components/VendorDetails/Loadable';
import VendorEventsListing from 'app/components/VendorEventsListing/VendorEventsListing';
import VendorEventsListingSkeleton from 'app/components/VendorEventsListing/VendorEventsListingSkeleton';
import { AxiosError } from 'axios';
import config from 'config/config';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetEventsByVendorIdQuery } from 'store/events/eventsApiSlice';
import HomePageMeta from './HomePageMeta';
import * as Sentry from '@sentry/react';

const HomePage: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { vendorId } = useParams();
  const [page, setPage] = useState(1);

  const { data, isLoading, isError, isFetching } = useGetEventsByVendorIdQuery({
    vendorId: vendorId as string,
    page,
  });

  if (isError) {
    throw new AxiosError('An error occured while loading events');
  }

  const loadMoreEvents = () => {
    // if you are at the bottom of the container which holds the infinite scroll
    // then setPage will be fired repeatedly until page equals data.totalPages
    if (
      data &&
      data.events.length !==
        page * config.homePageEvents.numberOfEventsDisplayed
    )
      return;
    setPage(page + 1);
  };

  return (
    <div className="page-container flex flex-col justify-between">
      <HomePageMeta
        events={data?.events}
        publicInformation={data?.vendor.publicInformation}
      />
      {vendorId === '03DG4Dzg' ? (
        <button
          onClick={() => {
            Sentry.captureException(new Error('test'));
          }}
        >
          throw error
        </button>
      ) : null}
      <div className="section-container w-full">
        {isLoading ? (
          <VendorEventsListingSkeleton />
        ) : (
          <VendorEventsListing
            events={data?.events}
            remainingEvents={data ? data.remainingEvents : 0}
            loadMoreEvents={loadMoreEvents}
            isFetching={isFetching}
          />
        )}
      </div>
      {data?.vendor?.publicInformation ? (
        <VendorDetails
          id={data.vendor.id}
          publicInformation={data.vendor.publicInformation}
          isLoading={isLoading}
        />
      ) : null}
    </div>
  );
};

export default HomePage;
